import { useNode } from "@craftjs/core";
import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import AudioIcon from "../../../../assets/images/segmentEditor/audio-icon.svg";
import { getSelectedSegment } from "../../../../redux/selectors/segmentBuilderSelectors";
import AudioBlock from "../../Shared/AudioBlock";
import { BlockIndicator } from "../../Shared/BlockIndicator";
import ImageBlock from "../../Shared/ImageBlock";
import AudioSettings from "./AudioSettings";
import useApplyGlobalSettings, {
  CODEBLOCK_TYPES,
} from "../../../../hooks/useApplyGlobalSettings";

export const Audio = ({
  audios,
  textColor,
  backgroundColor,
  waveColor,
  iconColor,
  margin,
  isApplyMarginOnAllSides,
  allSideMargin,
}) => {
  const {
    connectors: { connect, drag },
    actions: { setProp },
  } = useNode();

  const selectedSegment = useSelector(getSelectedSegment);
  const selectedSegmentColor = selectedSegment?.settings?.color;
  const { audio: audioProps } = useSelector((state) => state.codeblockStyles);
  const dispatch = useDispatch();

  const marginStyle =
    // isApplyMarginOnAllSides
    //   ? `${allSideMargin}px`
    //   :
    margin
      ? `${margin?.top}px ${margin?.right}px ${margin?.bottom}px ${margin?.left}px`
      : undefined;

  // Initialize with default props from reducer for new components
  useEffect(() => {
    // Set the props from the reducer if they're undefined
    const timeoutId = setTimeout(() => {
      setProp((props) => {
        // Audio-specific properties
        if (props.audios === undefined) {
          props.audios = [...audioProps.audios];
        }

        if (props.textColor === undefined) {
          props.textColor = audioProps.textColor;
        }

        if (props.backgroundColor === undefined) {
          props.backgroundColor =
            audioProps.backgroundColor || "suggested_color_0";
        }

        if (props.waveColor === undefined) {
          props.waveColor = audioProps.waveColor || "suggested_color_0";
        }

        if (props.iconColor === undefined) {
          props.iconColor = audioProps.iconColor || "suggested_color_0";
        }

        // Margin properties
        if (props.margin === undefined) {
          props.margin = { ...audioProps.margin };
        }

        if (props.isApplyMarginOnAllSides === undefined) {
          props.isApplyMarginOnAllSides = audioProps.isApplyMarginOnAllSides;
        }

        if (props.allSideMargin === undefined) {
          props.allSideMargin = audioProps.allSideMargin;
        }
      });
    }, 5);

    // Cleanup timeout if the component unmounts or dependencies change
    return () => clearTimeout(timeoutId);
  }, []);

  // Use the hook to apply global settings when they change
  useApplyGlobalSettings(setProp, CODEBLOCK_TYPES.Audio);

  return (
    <div ref={(ref) => connect(drag(ref))}>
      <BlockIndicator>
        {audios.length > 0 ? (
          <div
            style={{
              margin: marginStyle,
              gap: 10,
              display: "flex",
              flexDirection: "column",
            }}
          >
            {audios.map((item) => (
              <AudioBlock
                key={item.id}
                audio={item}
                textColor={textColor}
                backgroundColor={backgroundColor}
                waveColor={waveColor}
                iconColor={iconColor}
              />
            ))}
          </div>
        ) : (
          <div style={{ padding: 10 }}>
            <ImageBlock style={{ borderRadius: 8 }} src={AudioIcon} />
          </div>
        )}
      </BlockIndicator>
    </div>
  );
};

export const AudioDefaultProps = {
  audios: [],
  textColor: undefined,
  backgroundColor: undefined,
  waveColor: undefined,
  iconColor: undefined,
  margin: undefined,
  isApplyMarginOnAllSides: undefined,
  allSideMargin: undefined,
};

Audio.craft = {
  props: AudioDefaultProps,
  related: {
    settings: AudioSettings,
  },
};
